var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.channels"),
        subtitle: _vm.subtitle,
      },
    },
    [
      _c(
        "div",
        { staticClass: "channels" },
        _vm._l(_vm.channels, function (row) {
          return _c("div", { key: row.key, staticClass: "channels__row" }, [
            _c(
              "div",
              { staticClass: "channels__head" },
              [
                _c("feather-icon", {
                  class: "text-" + _vm.toneFor(row.key),
                  attrs: { icon: _vm.iconFor(row.key), size: "15" },
                }),
                _c("span", { staticClass: "channels__label" }, [
                  _vm._v(_vm._s(row.label)),
                ]),
                _c("span", { staticClass: "channels__pct" }, [
                  _vm._v(_vm._s(_vm.pctOf(row)) + "%"),
                ]),
                _c("span", { staticClass: "channels__count" }, [
                  _vm._v(_vm._s(row.conversions)),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "channels__bar" }, [
              _c("div", {
                staticClass: "channels__bar-fill",
                class: "channels__bar-fill--" + _vm.toneFor(row.key),
                style: { width: _vm.pctOf(row) + "%" },
              }),
            ]),
          ])
        }),
        0
      ),
      _vm.hasCoupon
        ? _c(
            "p",
            { staticClass: "channels__note" },
            [
              _c("feather-icon", { attrs: { icon: "InfoIcon", size: "13" } }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("influencer_panel.channels_coupon_note")) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }